import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default function getLocalTime(date: string, format: string) {
  const local = dayjs.utc(date).local().format(format);

  if (local === 'Invalid Date') {
    return '';
  }

  return local;
}
